import { render, staticRenderFns } from "./programme-type-list.vue?vue&type=template&id=7fc10afa&scoped=true"
import script from "./programme-type-list.vue?vue&type=script&lang=js"
export * from "./programme-type-list.vue?vue&type=script&lang=js"
import style0 from "./programme-type-list.vue?vue&type=style&index=0&id=7fc10afa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc10afa",
  null
  
)

export default component.exports